export default __webpack_public_path__ + "static/media/2408249.f23725af.webp";